import { useState } from "react";
import { PrimaryButton, Spinner } from "@graffer-inc/console-design-kit";

type DisableFunc = (value: string) => boolean;
type ValidatorFunc = (value: string) => string | undefined;

type InputWithButtonProps = {
  onSubmit: (value: string) => any;
  type: string;
  btnName: string;
  placeholder: string;
  disableFunc?: DisableFunc | ValidatorFunc;
};

export const InputWithButton = ({
  onSubmit,
  type,
  btnName,
  placeholder,
  disableFunc = () => false,
}: InputWithButtonProps) => {
  const [value, setValue] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const result = disableFunc(value);
  const disabled = typeof result === "boolean" ? result : !!result;

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        await onSubmit(value);
        setIsSubmitting(false);
      }}
    >
      <div className="field has-addons is-centered" style={{ marginTop: 15 }}>
        <div className="control is-expanded">
          <input
            className="input"
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            style={{
              fontSize: "14px",
            }}
          />
        </div>
        <div className="control">
          <PrimaryButton
            text={btnName}
            disabled={isSubmitting || disabled}
            type={"submit"}
          />
        </div>
      </div>
      {typeof result === "string" && <p className="help is-danger">{result}</p>}
      <Spinner loading={isSubmitting} />
    </form>
  );
};
